export const COMPLAINT_ACTIVE = new Set([1, 2, 7]);
export const COMPLAINT_ANALYSIS = new Set([2]);
export const COMPLAINT_FORWARDED = new Set([4, 10, 11, 12, 13]);
export const COMPLAINT_RESOLVED = new Set([3, 5, 8, 9]);

function asStatus(row) {
  return Number(row?.status || 0);
}

export function countComplaintGroups(list) {
  const rows = Array.isArray(list) ? list : [];
  const n = (set) => rows.filter((row) => set.has(asStatus(row))).length;
  return {
    total: rows.length,
    active: n(COMPLAINT_ACTIVE),
    analysis: n(COMPLAINT_ANALYSIS),
    forwarded: n(COMPLAINT_FORWARDED),
    resolved: n(COMPLAINT_RESOLVED),
    awaitingTriage: rows.filter((row) => asStatus(row) === 1).length,
  };
}
